import { request } from './client';

// Receipt history must keep its original contract even when retry is disabled.
export const UNME_CONTRACT_RECEIPT_ENABLED = ['1', 'true', 'yes', 'y'].includes(String(process.env.REACT_APP_UNME_CONTRACT_RECEIPT_ENABLED || '').trim().toLowerCase());

const text = (value) => typeof value === 'string' && value.trim() ? value.trim() : '-';

export function receiptSendError(error, fallback) {
  const msg = error?.response?.data?.msg ?? error?.msg ?? error?.message;
  const reason = error?.response?.data?.data?.reason ?? error?.data?.reason;
  if (UNME_CONTRACT_RECEIPT_ENABLED && (msg === 'UNME_RECEIPT_PROFILE_REQUIRED' || reason === 'UNME_RECEIPT_PROFILE_REQUIRED')) {
    return '전표 정보 등록이 필요합니다. 관리자에게 문의해 주세요.';
  }
  return fallback;
}

/** Resolve business information for the exact payment_transaction record. */
export async function resolveUnmeReceiptInfo({ role, transactionId, previewData, isDemo = false }) {
  if (!UNME_CONTRACT_RECEIPT_ENABLED || isDemo) return previewData;
  if (!['admin', 'cp', 'terminal'].includes(role) || !/^[1-9]\d*$/.test(String(transactionId ?? ''))) {
    throw new Error('결제 거래 정보를 확인할 수 없어 전표를 표시할 수 없습니다.');
  }
  let data;
  try {
    data = await request({ method: 'GET', url: `/api/${role}/receipt-info/payment/${transactionId}`, timeout: 30000 });
  } catch (error) {
    if (error?.code === 4090 || error?.response?.status === 409) {
      throw new Error('결제 계약 정보를 확인할 수 없습니다. 관리자에게 문의해 주세요.');
    }
    throw new Error('전표 정보를 불러오지 못했습니다. 다시 시도하거나 관리자에게 문의해 주세요.');
  }
  if (data?.receiptContract?.configured === false || data?.receiptContract?.source === 'MISSING' || !data?.supplierInfo || !data?.pgMerchantInfo) {
    throw new Error('전표 정보 등록이 필요합니다. 관리자에게 문의해 주세요.');
  }
  const supplier = data.supplierInfo;
  const pg = data.pgMerchantInfo;
  const merchant = data.merchantInfo || {};
  return {
    ...previewData,
    supplierName: text(supplier.name), supplierOwnerName: text(supplier.owner_name),
    supplierBusinessNo: text(supplier.business_no), supplierContact: text(supplier.contact), supplierAddress: text(supplier.address),
    cardMerchantName: text(pg.name), cardMerchantOwnerName: text(pg.owner_name),
    cardMerchantBusinessNo: text(pg.business_no), cardMerchantContact: text(pg.contact ?? pg.phone), cardMerchantAddress: text(pg.address),
    merchantName: text(merchant.name), merchantOwnerName: text(merchant.boss_name),
    merchantBusinessNo: text(merchant.business_no), merchantContact: text(merchant.phone), merchantAddress: text(merchant.address),
  };
}
